import { render, staticRenderFns } from "./CreateCertification.vue?vue&type=template&id=071c8bea"
import script from "./CreateCertification.vue?vue&type=script&lang=js"
export * from "./CreateCertification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports